import PropTypes from 'prop-types';
import { LearnMoreOption } from '~/helpers/enums';

const CustomDropdownItem = ({ label, onClick, style, popOverId, index }) => {
  if (onClick) {
    return (
      <button
        id={`pop-over-${popOverId}-selection`}
        key={label}
        type="button"
        className={`download-options-selection ${label === LearnMoreOption.LEARN_MORE ? 'divider' : ''}`}
        onClick={onClick}
        style={style}
      >
        {label}
      </button>
    );
  }

  return (
    <div id={`pop-over-${popOverId}-noop`} className={`download-options-noop ${index ? '' : 'divider'}`}>
      {label}
    </div>
  );
};

CustomDropdownItem.defaultProps = { onClick: undefined, style: {} };

CustomDropdownItem.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  index: PropTypes.number.isRequired,
  popOverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CustomDropdownItem;
